export const EXCEPTION_MOBILE_PATHS = ['/onboarding', '/profile', '/payment']
